function initImageText(section) {
  const inner = section.querySelector('[data-cit-inner]');
  if (!inner) return;

  const content = inner.querySelector('[data-cit-content]');
  const body    = inner.querySelector('[data-cit-body]');
  const btn     = inner.querySelector('[data-cit-toggle]');
  const imageEl = inner.querySelector('[data-cit-image]');

  if (content) {
    const ps = content.querySelectorAll('p');
    if (ps.length) ps[ps.length - 1].style.setProperty('margin-bottom', '0', 'important');
  }

  const MOBILE_BP = 991;
  const isRatio = inner.dataset.citMediaMode === 'ratio';

  if (!isRatio || !content || !body || !btn || !imageEl) {
    if (btn) btn.hidden = true;
    return;
  }

  if (!body.id) body.id = 'cit-body-' + Math.random().toString(36).slice(2, 8);
  btn.setAttribute('aria-controls', body.id);
  btn.setAttribute('aria-expanded', 'false');

  function isMobile() { return window.innerWidth <= MOBILE_BP; }
  function imgHiddenDesktop() { return imageEl.dataset.citImgDesktop === 'false'; }

  function bodyOverflows() {
    return body.scrollHeight > body.clientHeight + 4;
  }

  function collapse() {
    inner.classList.add('is-clipped');
    inner.classList.remove('is-expanded');
    imageEl.style.height = '';
    const h = imageEl.getBoundingClientRect().height;
    content.style.height = h + 'px';
    btn.textContent = btn.dataset.labelMore;
    btn.setAttribute('aria-expanded', 'false');
  }

  function expand() {
    inner.classList.add('is-expanded');
    inner.classList.remove('is-clipped');
    content.style.height = '';
    btn.textContent = btn.dataset.labelLess;
    btn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      const h = content.getBoundingClientRect().height;
      imageEl.style.height = h + 'px';
    });
  }

  function setup() {
    if (isMobile() || imgHiddenDesktop()) {
      inner.classList.remove('is-clipped', 'is-expanded');
      imageEl.style.height = '';
      content.style.height = '';
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      return;
    }
    if (inner.classList.contains('is-expanded')) return;

    inner.classList.add('is-clipped');
    imageEl.style.height = '';
    const h = imageEl.getBoundingClientRect().height;
    content.style.height = h + 'px';

    if (bodyOverflows()) {
      btn.hidden = false;
      btn.textContent = btn.dataset.labelMore;
      btn.setAttribute('aria-expanded', 'false');
    } else {
      inner.classList.remove('is-clipped');
      content.style.height = '';
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  btn.addEventListener('click', () => {
    inner.classList.contains('is-expanded') ? collapse() : expand();
  });

  const controller = new AbortController();
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setup, 150);
  }, { passive: true, signal: controller.signal });

  let roTimer;
  const ro = new ResizeObserver(() => {
    if (inner.classList.contains('is-expanded')) return;
    clearTimeout(roTimer);
    roTimer = setTimeout(setup, 100);
  });
  ro.observe(imageEl);

  if (section.parentNode) {
    const cleanupMo = new MutationObserver(() => {
      if (!document.contains(section)) {
        controller.abort();
        ro.disconnect();
        cleanupMo.disconnect();
      }
    });
    cleanupMo.observe(section.parentNode, { childList: true });
  }

  requestAnimationFrame(setup);
}

document.querySelectorAll('[data-cit-section]').forEach(initImageText);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-cit-section]').forEach(initImageText);
  });
}